export default "__VITE_ASSET__BNcEfJLA__"